module.exports = __webpack_public_path__ + "media/images/frontend/pages/home-9-28eb582467096328a4d9261bf47ce3a9.jpg";